<div class="modal-header p-3" style="background-color: var(--tb-primary); color: white;">
  <h5 class="modal-title mb-0">
    <i class="bi {{ icon }} me-2"></i>
    <span *ngIf="translateKeys" [tmwTranslate]="title" [translateValues]="translateValues"></span>
    <span *ngIf="!translateKeys">{{ title }}</span>
  </h5>
  <button type="button" class="btn-close btn-close-white" aria-label="Fermer" (click)="cancel()"></button>
</div>

<div class="modal-body p-4">
  <div class="text-center">
    <div class="mb-3">
      <i class="bi {{ icon }}" style="font-size: 3rem; color: var(--tb-primary);"></i>
    </div>
    <p class="mb-0">
      <span *ngIf="translateKeys" [tmwTranslate]="message" [translateValues]="translateValues"></span>
      <span *ngIf="!translateKeys">{{ message }}</span>
    </p>
  </div>
</div>

<div class="modal-footer p-3">
  <div class="d-flex justify-content-end w-100">
    <button type="button" class="btn btn-light me-2" (click)="cancel()">
      <i class="bi bi-x-lg me-1"></i><span tmwTranslate="entity.action.cancel">Annuler</span>
    </button>
    <button type="button" class="btn {{ confirmClass }}" (click)="confirm()">
      <i class="bi {{ icon }} me-1"></i>
      <span *ngIf="translateKeys" [tmwTranslate]="confirmLabel" [translateValues]="translateValues"></span>
      <span *ngIf="!translateKeys">{{ confirmLabel }}</span>
    </button>
  </div>
</div>
